import React, {useEffect, useState} from "react";
import Forms from "../../../bricks/form/Forms";
import TestQuestionAdministration from "../testQuestion/TestQuestionAdministration";
import {useAppData} from "../../../context/AppDataContext";
import Loading from "../../../bricks/Loading";
import OtherTestModalContent from "./OtherTestModalContent";
import {useModal} from "../../../context/ModalContext";

import "./OtherTestAdministration.css";

const OtherTestAdministration = () => {
    const {period} = useAppData();
    const [selectedOtherTest, setSelectedOtherTest] = useState(null);
    const [otherTestList, setOtherTestList] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const {openModal} = useModal();
    const [version, setVersion] = useState(0);

    useEffect(() => {
        if (period) {
            setOtherTestList(period?.otherTestList?.map(test => ({
                value: test._id,
                label: `${test.name} (min. ${test.percentPassedThreshold}%)`
            })) || []);
            const testExists = period?.otherTestList.find(test => test._id === selectedOtherTest);
            if (testExists) setVersion(v => v + 1);
            else setSelectedOtherTest(null);
        }
        setIsLoading(false);
    }, [period]);

    const handleSelectNewTest = (testId) => {
        setSelectedOtherTest(testId);
    }

    const handleModalOpen = (selectedTestId) => {
        openModal(OtherTestModalContent, {
            handleSelectNewTest,
            testData: period.otherTestList.find(test => test._id === selectedTestId)
        }, {
            title: selectedOtherTest ? "Upravit test" : "Vytvořit nový test"
        });
    }

    const renderContent = () => {
        if (isLoading) {
            return <Loading/>;
        } else {
            return (
                <div className="wrapper">
                    <div className="header">
                        <h2>Nastavení ostatních testů</h2>
                        <div className="controls">
                            <Forms.AddIcon title="Vytvořit" onClick={() => handleModalOpen()}/>
                            {selectedOtherTest && <Forms.EditIcon title="Upravit test"
                                                                  onClick={() => handleModalOpen(selectedOtherTest)}/>}
                        </div>
                    </div>
                    <Forms.Select inline label="Vyberte test: " colWidth="col-3" options={otherTestList} emptyOption
                                  value={selectedOtherTest} onChange={(_, testId) => setSelectedOtherTest(testId)}/>
                    {
                        selectedOtherTest &&
                        <TestQuestionAdministration key={`${selectedOtherTest}_${version}`}
                                                    type="otherTest"
                                                    testId={selectedOtherTest}
                                                    hideInfo
                                                    allowDelete
                        />
                    }
                </div>
            )
        }
    }

    return renderContent();
};

export default OtherTestAdministration;
